;(function($, undefined){
    'use strict';

    var _ = window._;
    var rnn = window.rnn;
    var store = window.store;
    var log = rnn.logging.log;
    var registeredUser = false;
    var activeModal = false;
    var counterChecks = {};

    function addChargifyReturnURL(restrictionType) {
        // Add a return URL to a cookie, so that the user can return to the page that
        // they were viewing before they got this annoying popup. We can then use that
        // value later down the chain after they finish subscribing on chargify?
        // This sets it even if it's for registration though, so don't let it confuse you.
        var path = window.location.pathname.toLowerCase();
        var options = {
            expires: new Date(rnn.modules.time.current().getTime() + 72e+5),
            path: '/'
        };
        var cookieName = restrictionType + '_return_url';

        if (Cookies.get(cookieName) === undefined) {
            Cookies.set(cookieName, path,  options);
        }
    }

    function initSubModalTracking(actionType){
        // GA Tracking for the Paywall Redirect
        var trackData = {
          tracker: 'send',
          hitType: 'event',
          category: 'subscription modal',
          action: actionType,
          token: 'subModalEvent'
        };

        rnn.modules.g_analytics.create_ga_event(trackData);
        rnn.modules.omniture.trackCustomOmnitureEvent('event38', actionType);
    }

    function initCounterModalTracking(){
        // track this in GA.
        var category = 'subscription counter';
        var action = 'view';

        var trackData = {
            tracker: 'send',
            hitType: 'event',
            category: category,
            action: action,
            token: 'subModalEvent'
        };

        // view event
        rnn.modules.g_analytics.create_ga_event(trackData);
        rnn.modules.omniture.trackCustomOmnitureEvent('event37', 'counter');

        $('.restrictionCounterModal .track').click(function() {
            if($(this).data('track').action){
                var action = $(this).data('track').action;
                trackData.action = action;
                rnn.modules.g_analytics.create_ga_event(trackData);
            }
        });
    }

    function redirectToPage(isPremium) {
        initSubModalTracking("direct"); //track this as a redirect
        var _redir={redir:document.createElement("a")};
        var url = window.location;
        var redirectPage = "/subscriptions/" + (isPremium ? "premium" : "direct") + "/";
        var redirect_url = location.protocol + '//' + url.host + redirectPage;
        _redir.redir.href= redirect_url;
        _redir.cur=window.location.search;
        if (_redir.cur) {_redir.redir.search=_redir.redir.search ? _redir.cur + "&" + _redir.redir.search.slice(1) : _redir.cur;}
        window.location.replace(_redir.redir.href);
    }

    function check_restriction(restriction, restrictionID) {
        var storageKey = 'restriction_' + restrictionID;
        var storageRestriction = store.get(storageKey, true);
        var path = window.location.pathname.toLowerCase();
        var restrictionTypes = ['registration', 'subscription'];
        var premiumContent = pageData.isPremium;
        var now = rnn.modules.time.current();
        var created;

        if (registeredUser) {
            restrictionTypes.shift();
        }

        if (storageRestriction === undefined) {
            storageRestriction = create_restriction(restriction);

        } else {
            created = rnn.modules.time.zuluStringToLocalDate(storageRestriction.created);

            if (created - now < 0) {
                store.remove(storageKey);
                storageRestriction = create_restriction(restriction);
            }
        }

        restrictionTypes.every(function(restrictionType) {
            var restrictionImpressionsFieldName = restrictionType + '_impressions';
            var maxRestrictionImpressions = restriction[restrictionType + '_impressions_limit'];

            if (premiumContent) {
                redirectToPage(true);

            } else if (maxRestrictionImpressions !== null && /^\d+$/.test(maxRestrictionImpressions.toString())) {
                // If the user has not already visited this particular page, then it's party time.
                if (!_.contains(storageRestriction[restrictionImpressionsFieldName], path)) {
                    if (storageRestriction[restrictionImpressionsFieldName].length >= maxRestrictionImpressions) {
                        addChargifyReturnURL(restrictionType);
                        redirectToPage(false);
                        return false;
                    } else {
                        // if the restriction is subscription and no counter modals are currently open/loading
                        if (restrictionType === 'subscription') {
                            // store counter checks in a var so we can check them after modal checks are done
                            counterChecks[restriction.slug] = {
                                'visited': storageRestriction[restrictionImpressionsFieldName].length,
                                'restricted': maxRestrictionImpressions
                            };
                        }
                        storageRestriction[restrictionImpressionsFieldName].push(path);
                    }
                }
            }

            return true;
        });

        // The "true" argument here is saying to b64 encode the restriction in the storage.
        // The fact that we use an outdated version of a store.js plugin from github,
        // with no mention of it in this file, means that I am forced to put this comment here.
        store.set(storageKey, storageRestriction, true);
    }

    function restrictionCounter(visitedNumber, restrictNumber, restrictionSlug, checkArray) { //optional checktype
        var defaultCheckArray = [3,5,7,9];
        var fragmentHeader = 'cp_modal_counter_header_' + restrictionSlug;
        var fragmentBody = 'cp_modal_counter_body_' + restrictionSlug;
        var fragmentHeaderDefault = 'cp_modal_counter_header_default';
        var fragmentBodyDefault = 'cp_modal_counter_body_default';
        var checkCondition = false;

        if(checkArray === undefined) {
            //use the default
            checkArray = defaultCheckArray;
        }

        if (checkArray.indexOf(visitedNumber+1) >= 0) {
            activeModal = true;

            $.ajax({
                url: '/fragments/get/?slug=' + fragmentHeader + '&slug=' + fragmentBody + '&slug=' + fragmentHeaderDefault + '&slug=' + fragmentBodyDefault,
                success: function(data) {
                    var header = '';
                    var body = '';

                    // fragment fallback logic
                    if (data[fragmentHeader].rendered_text !== '') {
                        header = data[fragmentHeader].rendered_text;
                    } else {
                        header = data[fragmentHeaderDefault].rendered_text;
                    }
                    if (data[fragmentBody].rendered_text !== '') {
                        body = data[fragmentBody].rendered_text;
                    } else {
                        body = data[fragmentBodyDefault].rendered_text;
                    }

                    var $counterModal = $(
                        '<div class="modal hide restrictionCounterModal">' +
                            '<div class="modal-header">' + header +
                                '<button type="button" class="close track" data-track="{&quot;action&quot;: &quot;click close&quot;}" data-dismiss="modal" aria-hidden="true">&times;</button>' +
                            '</div>' +
                            '<div class="modal-body">' + body + '</div>' +
                        '</div>'
                    );

                    $('body').append($counterModal);

                    // load the modal and add the numbers to the content
                    $counterModal.modal({ backdrop: false });
                    $counterModal.find('.readNumber').html(visitedNumber+1).end()
                                 .find('.remainNumber').html(restrictNumber - visitedNumber - 1).end()
                                 .find('.restrictNumber').html(restrictNumber);

                    // you're a cruel beast bootstrap 3
                    $('body').removeClass('modal-open');

                    initCounterModalTracking();
                }
            });
        }
    }

    function create_restriction(restriction) {
        return {
            'registration_impressions': [],
            'subscription_impressions': [],
            'created': new Date(rnn.modules.time.current().getTime() + (Number(restriction.numDays) * 864e+5))
        };
    }

    function hideCloseButton(){
        $('[data-noexit]').each(function() {
            var $this = $(this);

            if ($this.data('noexit') === true){
                $this.remove();
            }
        });
    }

    function subscriptionReturnURL() {
        var current_path = window.location.pathname;
        Cookies.set('subscription_return_url', current_path, {expires: 1, path: '/'});
    }

    function init(checkType) { //accept optional checktype to change the counter modal behaviour
        var restrictionsEnabled = rnn.site.restrictionsEnabled;
        var restrictions = rnn.site.restrictions;

        if (Cookies.get('premium_subscription_redirect')) {
            Cookies.remove('premium_subscription_redirect');
            initSubModalTracking("direct"); //track this as a redirect
        }

        if (restrictionsEnabled && !_.isEmpty(restrictions) && !store.disabled) {
            if (Cookies.get('subscribed') || Cookies.get('norestrict') || Cookies.get('cspbypass')) {
                return;
            }

            rnn.modules.user.get(function(user) {
                if (user.authenticated) {
                    registeredUser = true;

                    if (user.subscribed) {
                        return;
                    }
                } else if (user.norestrict) {
                    return;
                }

                _.each(restrictions, function(restriction, restrictionID) {
                    check_restriction(restriction, restrictionID);
                });

                // loop through the counter checks, if there are no active modals run the checks
                _.each(counterChecks, function(values, slug) {
                    if (!activeModal) {
                        if(checkType === undefined) {
                            restrictionCounter(values.visited, values.restricted, slug);
                        } else {
                            restrictionCounter(values.visited, values.restricted, slug, checkType);
                        }
                    }
                });
            });
        }
        hideCloseButton();
    }

    rnn.modules.register("restrictions", {
        init: init,
        hideCloseButton: hideCloseButton,
        subscriptionReturnURL: subscriptionReturnURL,
        initSubModalTracking: initSubModalTracking
    });

})(jQuery);
